import { useState, useEffect, useMemo, useCallback } from "react";
import Loader from "./Loader";
import Congratulations from "./Congratulations";
import PinVerificationModal from "./reusable/PinVerificationModal";
import {
  getOrderDetails,
  getdeliverytime,
  getGeofenceByFleetId,
  getFleetConfigByFleetId,
} from "../API";
import { findNorthWestAndSouthEast } from "../utils";
import { ORDER_STATUS_CODE } from "../constants/enums";

import { useParams, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
function OrderStatus() {
  const [isLoading, setIsLoading] = useState(true);
  const [orderDetails, setorderDetails] = useState(null);
  const [etaDetails, setETADetails] = useState(null);
  const [etaLoader, setETALoader] = useState(true);
  const { orderID } = useParams();
  const [otp, setOtp] = useState(orderID?.substr(-4));
  const history = useNavigate();
  const [maxBoundCordinates, setBoundCordinates] = useState({});
  const [expectedPin, setExpectedPin] = useState(null);
  const [pinVerified, setPinVerified] = useState(false);
  const [searchParams] = useSearchParams();
  const useMockData = searchParams.get("mock") === "1";

  const mockBounds = useMemo(
    () => ({
      southwest: [119.093957, -22.539033],
      northeast: [119.094929, -22.538134],
    }),
    []
  );

  const mockOrderDetails = useMemo(
    () => ({
      orderId: orderID || "000000",
      orderStatus: "Waiting at dropoff",
      statusCode: ORDER_STATUS_CODE.ARRIVED_DELIVERY,
      ETA: 300,
      orderDropLocation: {
        locationName: "M053",
        latitude: -22.540957,
        longitude: 119.094031,
        positionX: 119.094031,
        positionY: -22.540957,
      },
      orderPickupLocation: {
        locationName: "TAVERN",
        latitude: -22.53888658878663,
        longitude: 119.09457175414248,
        positionX: 119.09457175414248,
        positionY: -22.53888658878663,
      },
      robotLocation: {
        latitudeSlam: -22.540957,
        longitudeSlam: 119.094031,
        headingSlam: 180,
      },
      robotName: process.env.REACT_APP_DUMMY_ROBOT_NAME || "OTTOBOT-001",
      robotId: "dummy-robot-001",
      customerName: "Demo Customer",
      qrcode: "demo",
      pin: "1234",
      fleetId: process.env.REACT_APP_FLEETID || "dummy-fleet",
    }),
    [orderID]
  );
  const fetchBoundCordinates = useCallback(() => {
    if (useMockData) {
      setBoundCordinates(mockBounds);
      return;
    }
    getGeofenceByFleetId(process.env.REACT_APP_FLEETID).then((res) => {
      setBoundCordinates(findNorthWestAndSouthEast(res.data.geofence));
    });
  }, [mockBounds, useMockData]);
  const fetchOrderDetails = useCallback(() => {
    getOrderDetails(orderID)
      .then((res) => {
        const data = res?.data?.data;
        const pinVal = data?.pin;
        if (pinVal != null && String(pinVal).trim() !== "") {
          setExpectedPin(String(pinVal).trim());
        }
        localStorage.setItem("name", data?.name);
        localStorage.setItem("email", data?.email);
        localStorage.setItem("phone", data?.phone);
        sessionStorage.setItem("pin", data?.pin);
        if (Number(process.env.REACT_APP_ONLYPICKUP)) {
          if (res?.data?.data?.statusCode > ORDER_STATUS_CODE.PICKED_UP) {
            if ([ORDER_STATUS_CODE.CANCELLED_BEFORE_PICKUP, ORDER_STATUS_CODE.CANCELLED_AFTER_PICKUP_BEFORE_DELIVERY, ORDER_STATUS_CODE.CANCELLED_ALT, ORDER_STATUS_CODE.RETRIEVED].includes(res.data?.data.statusCode)) {
              history(`/ordercancel/${orderID}`);
            } else {
              history(`/orderpickedup/${orderID}`);
            }
          }
        } else {
          if (res.data?.data?.statusCode === ORDER_STATUS_CODE.DELIVERED) {
            history(`/orderdelivered/${orderID}`);
          }
          if ([ORDER_STATUS_CODE.CANCELLED_BEFORE_PICKUP, ORDER_STATUS_CODE.CANCELLED_AFTER_PICKUP_BEFORE_DELIVERY, ORDER_STATUS_CODE.RETURN_INITIATED, ORDER_STATUS_CODE.RETURNING, ORDER_STATUS_CODE.RETURNED, ORDER_STATUS_CODE.RETRIEVED].includes(res.data?.data.statusCode)) {
            history(`/ordercancel/${orderID}`);
          }
        }
        setorderDetails(data);

        setOtp(orderID.substr(-4));
      })
      .catch((err) => {
        console.log("Error ", err);
      });
  }, [history, orderID]);

  useEffect(() => {
    if (useMockData) {
      setorderDetails(mockOrderDetails);
      setBoundCordinates(mockBounds);
      setOtp(orderID?.substr(-4));
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    fetchOrderDetails();
    fetchBoundCordinates();
  }, [
    orderID,
    useMockData,
    mockOrderDetails,
    mockBounds,
    fetchOrderDetails,
    fetchBoundCordinates,
  ]);

  useEffect(() => {
    if (useMockData) return;
    const intervalId = setInterval(fetchOrderDetails, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [useMockData, fetchOrderDetails]);
  useEffect(() => {
    if (useMockData) {
      setETADetails({ totalEta: 300, pickupEta: 0 });
      setETALoader(false);
      return;
    }
    const intervalId = setInterval(() => {
      getdeliverytime(orderID)
        .then((res) => {
          setETADetails(res?.data?.result);
          setETALoader(false);
        })
        .catch((err) => {
          setETALoader(true);
          console.log("Error ", err);
        });
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [orderID, useMockData]);
  useEffect(() => {
    if (useMockData) {
      localStorage.setItem(
        "fleetConfig",
        JSON.stringify({
          operatorPhone: "+61212345678",
          supportMail: "support@ottonomy.io",
        })
      );
      return;
    }
    const fetchFleetConfig = async () => {
      try {
        const response = await getFleetConfigByFleetId(process.env.REACT_APP_FLEETID);
        const data = response?.data?.data;
        localStorage.setItem("fleetConfig", JSON.stringify(data));
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchFleetConfig();
  }, [useMockData]);

  useEffect(() => {
    if (!useMockData) return;
    localStorage.setItem("phone", "+61 400 9291");
    localStorage.setItem("name", "Demo Customer");
    localStorage.setItem("email", "demo@ottonomy.au");
    sessionStorage.setItem("pin", mockOrderDetails.pin);
    setOtp(orderID?.substr(-4) || "1234");
  }, [useMockData, mockOrderDetails, orderID]);

  const pinRequired = expectedPin != null && expectedPin !== "";
  const showContent = !isLoading && (!pinRequired || pinVerified);

  return (
    <div>
      <PinVerificationModal
        open={pinRequired && !pinVerified}
        expectedPin={expectedPin}
        onVerified={() => setPinVerified(true)}
      />
      {!showContent && isLoading ? (
        <Loader />
      ) : showContent ? (
        <Congratulations
          maxBoundCordinates={maxBoundCordinates}
          orderDetails={orderDetails}
          otp={otp}
          eta={etaDetails}
          etaLoader={etaLoader}
          isLoading={isLoading}
        />
      ) : null}
    </div>
  );
}

export default OrderStatus;
